var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-0 mr-0 mt-0 box"},[_c('apex-chart',{ref:"apexChart",attrs:{"height":"400","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }